<template>
  <div>
    <v-chart :options="option" 
    :autoresize="true"
    :style="{height:'200%'}"
    />
    <div v-if="cpuvalue < 5 " class="statusgauge"> LOW </div>
    <div v-else-if="cpuvalue < 8" class="statusgauge"> Medium </div>
    <div v-else class="statusgauge"> HIGH </div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'cpuGauge',
  props: {
    value: {
      type: Number,
    }
  },
  data() {
    return {
      cpuvalue: '',
      option: {
        title: {
          show: true,
          textStyle: {
            color: '#ccc',
            fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
          },
        },
        tooltip: {
          formatter: '{a} <br/>{b} : {c}'
        },
        toolbox: {},
        series: [
          {
            name: 'CPU Load',
            type: 'gauge',
            center: ['50%', '50%'],
            startAngle: 200,
            endAngle: -20,
            min: 0,
            max: 9,
            radius: '80%',
            splitLine: {
              show: true,
            },
            axisLine: {
              lineStyle: {
                color: [
                  [
                    1,
                    new echarts.graphic.LinearGradient(0, 0.5, 1, 1 , [
                      {
                        offset: 0,
                        color: '#1E9600',
                      },
                      {
                        offset: 0.5,
                        color: '#FFF200',
                      },
                      {
                        offset: 1,
                        color: '#FF0000',
                      },
                    ]),
                  ],
                  // [1, '#00000'],
                ],
                width: 30,
                opacity: 1,
              },
            },
            axisTick: {
              show: false,
            },
            detail: {
              textStyle: {
                color: 'black',
                fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
                fontSize: 25,
              },
            },
            data: [{ value: this.value}],
            axisLabel: {
              show: false,
            },
            title: {
              textStyle: {
                color: 'black',
              },
            },
            itemStyle: {
              color: '#696969',
            },
          },
        ],
      },
    }
  },
  methods: {
    getCpuValue() {
      this.cpuvalue = this.value
    }
  },
  mounted() {
    this.getCpuValue()
  }
}
</script>

<style>
.echarts {
  max-width: 100%;
  max-height: 100%;
}
.statusgauge {
  margin-top: -50px;
}
</style>
